import { WIDGET } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
export const goBack = async (action, _datastore, { goBack, appendWidgets }) => {
    await appendWidgets(ROUTE.MF_FETCH_PORTFOLIO, {
        error_msg: {
            label: "We couldn’t find a portfolio match your details. Please review & try again.",
        },
    }, [{ id: "error_msg", type: WIDGET.MESSAGE }]);
    await goBack();
};
